import {INIT_SEARCH_FILTER} from "../components/init-search-filter.js";
import {INIT_SEARCH_AGAIN} from "../components/init-search-again.js";

document.addEventListener('DOMContentLoaded', () => {
    const SEARCH_FILTER = document.querySelector('[data-search-filter]');
    if (SEARCH_FILTER) INIT_SEARCH_FILTER(SEARCH_FILTER);

    const SEARCH_AGAIN_BUTTON = document.querySelector('[data-search-again]');
    if (SEARCH_AGAIN_BUTTON) INIT_SEARCH_AGAIN(SEARCH_AGAIN_BUTTON);
});
